import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import { rootEventBus, EnumRootEventBus } from "../managers/RootEventBus";
import { CircleInt, Coord } from "../types/Interface";
import { INITIAL_CIRCLE_RADIUS } from "../types/Config";
import generatePoints from "../utils/generator/generatePoints";


export default class Circle extends PIXI.Container {
  private Layers = Layers.getInstance();
  private arcs: PIXI.Graphics[] = [];
  private colors: number[] = [];
  private strokeW: number = 5;
  radius: number = INITIAL_CIRCLE_RADIUS;
  radians: number[] = [];
  points: Coord[] = [];

  constructor(coord: Coord, radians: number[], colors: number[], strokeW: number = 5) {
    super();
    Object.assign(this, coord);
    this.radians = radians;
    this.colors = colors;
    this.strokeW = strokeW;
    this.addGraphics(radians.length);
    this.addToLayer();

    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll());
  }

  private addToLayer = () => this.Layers.Middle.addChild(this);
  setColors = (colors: number[]) => this.colors = colors;
  setRadians = (radians: number[]) => this.radians = radians;
  addGraphics(count: number) {
    this.arcs = Array(count).fill(new PIXI.Graphics());
    this.arcs.forEach(arc => this.addChild(arc));
  }
  clearAll = () => this.arcs.forEach(arc => arc.clear());
  draw(details: CircleInt, transparent = false) {
    Object.assign(this, details);
    const alpha = transparent ? 0 : 1;
    const points = generatePoints({ x: 0, y: 0 }, this.radians, this.radius);
    this.clearAll();

    this.radians.forEach((r, rI) => {
      const ONE_DEGREE = Math.PI / 180
      const lastelm = rI == this.radians.length - 1;
      const arc = this.arcs[rI]
      const point = points[rI];
      const endAngle = this.radians.length !== 1 ? this.radians[!lastelm ? rI + 1 : 0] : ONE_DEGREE * (r / ONE_DEGREE - 1);

      arc
        .moveTo(point.x, point.y)
        .arc(0, 0, this.radius, r, endAngle)
        .stroke({ color: this.colors[rI], width: this.strokeW, alpha: !lastelm ? alpha : 1, cap: "round" });
    })
  }
}